import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {

  // solo números
  static numericOnly(): ValidatorFn {
    return (ctrl: AbstractControl): ValidationErrors | null => {
      if (!ctrl.value) return null;
      return /^\d+$/.test(ctrl.value)
        ? null
        : { numericOnly: true };
    };
  }

  // sin espacios al inicio o al final
  static noWhitespace(): ValidatorFn {
    return (ctrl: AbstractControl): ValidationErrors | null => {
      if (!ctrl.value) return null;
      return ctrl.value.trim().length === ctrl.value.length
        ? null
        : { noWhitespace: true };
    };
  }

  // longitud exacta (ej: cédula de 10 dígitos)
  static exactLength(length: number): ValidatorFn {
    return (ctrl: AbstractControl): ValidationErrors | null => {
      if (!ctrl.value) return null;
      return String(ctrl.value).length === length
        ? null
        : { exactLength: { required: length, actual: ctrl.value.length } };
    };
  }

  // comparar dos campos (ej: confirmar contraseña)
  static matchField(targetId: string): ValidatorFn {
    return (ctrl: AbstractControl): ValidationErrors | null => {
      const parent = ctrl.parent;
      if (!parent) return null;
      const target = parent.get(targetId);
      return target && ctrl.value === target.value
        ? null
        : { matchField: { target: targetId } };
    };
  }

  // fecha no puede ser pasada
  static notPastDate(): ValidatorFn {
    return (ctrl: AbstractControl): ValidationErrors | null => {
      if (!ctrl.value) return null;
      const selected = new Date(ctrl.value);
      const today    = new Date();
      today.setHours(0, 0, 0, 0);
      return selected >= today ? null : { notPastDate: true };
    };
  }

  // correo estricto: requiere TLD de al menos 2 letras
  static strictEmail(): ValidatorFn {
    const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z]{2,})+$/;
    return (ctrl: AbstractControl): ValidationErrors | null => {
      if (!ctrl.value) return null;
      return EMAIL_REGEX.test(ctrl.value) ? null : { email: true };
    };
  }

  // mínimo de opciones seleccionadas (para multiselect)
  static minSelect(min: number): ValidatorFn {
    return (ctrl: AbstractControl): ValidationErrors | null => {
      const value = ctrl.value;
      if (!Array.isArray(value) || value.length === 0) return null; // required lo cubre
      return value.length >= min
        ? null
        : { minSelect: { required: min, actual: value.length } };
    };
  }

  // máximo de opciones seleccionadas (para multiselect)
  static maxSelect(max: number): ValidatorFn {
    return (ctrl: AbstractControl): ValidationErrors | null => {
      const value = ctrl.value;
      if (!Array.isArray(value)) return null;
      return value.length <= max
        ? null
        : { maxSelect: { required: max, actual: value.length } };
    };
  }
}